/* eslint-disable @typescript-eslint/no-extraneous-class */
import { get } from 'aws-amplify/api'
import { environment } from '../environment'

interface DocumentType {
  key: string
  url: string
}

export interface Attachment {
  key: string
  url: string
}

class AttachmentServiceInstance {
  async getAttachments (number: string): Promise<Attachment[] | undefined> {
    try {
      console.log('Fetching attachments for', number)
      const response = await get({
        apiName: environment.apiName,
        path: `${environment.apiPaths.attachments}/${number}`
      }).response
      return await (response.body.json() as unknown as Promise<DocumentType[]>)
    } catch (error: any) {
      if (error.response?.statusCode !== 404) {
        console.error('Error fetching attachments', error)
      }
    }
  }
}

class AttachmentServiceSingleton {
  private static instance: AttachmentServiceInstance | null = null

  static getInstance (): AttachmentServiceInstance {
    if (AttachmentServiceSingleton.instance === null) {
      AttachmentServiceSingleton.instance = new AttachmentServiceInstance()
    }
    return AttachmentServiceSingleton.instance
  }
}

export const attachmentService = AttachmentServiceSingleton.getInstance()
